import { useState } from 'react';

import { Wrapper } from '@klv/utils/wrapper';
import { generateClassName } from '@klv/shared/utils/functions';
import { ReactFlowProvider } from '@xyflow/react';

import { Hero } from './hero';
import { FlowsAI } from './flows';
import * as styles from './styles/flowsAi.module.scss';
import { FlowsFormSlideProvider } from './context/flowsFormSlide';

export const FlowsAi = () => {
  const [page, setPage] = useState('hero'); 

  return (
    <Wrapper 
      backgroundColor="white"
      inlinePadding={false}
      contained={false}
      grid={true}
      customPadding={{ customPaddingTop: 'none', customPaddingBottom: 'none' }}
    >

      {/* Show the Hero page */}
      <div className={generateClassName([styles.flowsAiPage, page === 'hero' ? styles.active : styles.inactive])}>
        <Hero setPage={setPage}/>
      </div>
      
      {/* Show the Flows page */}
      <div className={generateClassName([styles.flowsAiPage, page === 'flows' ? styles.active : styles.inactive])}>
        <FlowsFormSlideProvider>
          <ReactFlowProvider>
            <FlowsAI setPage={setPage}/>
          </ReactFlowProvider>
        </FlowsFormSlideProvider>
      </div>
    </Wrapper>
  );
};
